<template>
  <div v-if="event !== undefined">
    <Onboarding
      v-if="onboarding"
      :is-translator="isTranslator"
      :is-hybrid-user="isHybridUser"
      :event="event"
      @update-active="setActive"
    />
    <Room v-if="!onboarding" :is-translator="isTranslator" :is-hybrid-user="isHybridUser" @update-active="setActive" />
  </div>
</template>
<script>
/**
 * Entrypoint in the Conference
 * initially setting up different variables based on the users role
 * @displayName Mediasoup Event
 */
import Room from "./Room.vue";
import Onboarding from "./Onboarding.vue";
import { mapState } from "vuex";
import { detect } from "detect-browser";
/* eslint-disable no-unused-vars*/
import { auth, db, functions, FieldValue } from "@/firebase";

export default {
  name: "MediasoupEvent",
  components: {
    Room,
    Onboarding,
  },
  data() {
    return {
      event: undefined,
    };
  },
  computed: {
    ...mapState({
      onboarding: (state) => state.mediasoup.onboarding,
      role: (state) => state.mediasoup.role,
    }),
    isTranslator() {
      return this.role === "translator";
    },
    isHybridUser() {
      return this.role === "hybrid";
    },
    participantsCollection() {
      return db.collection(
        `organizations/${this.$route.params.organizationId}/events/${this.$route.params.eventId}/participants`,
      );
    },
    translatorsCollection() {
      return db.collection(
        `organizations/${this.$route.params.organizationId}/events/${this.$route.params.eventId}/translators`,
      );
    },
  },
  async created() {
    // Redirecting to google if there is no event data available
    const eventRef = db.doc(`organizations/${this.$route.params.organizationId}/events/${this.$route.params.eventId}`);
    const eventData = (await eventRef.get()).data();
    console.log("File: MediasoupEvent.vue, event: ", eventData);

    if (eventData.name) {
      // Joining test viewers for testing
      if (this.$route.query.testViewer === "true") {
        this.browserCheck();
        if (this.$store.getters.getCurrentUser == null) {
          await auth.signInAnonymously();
        }
        let mediasoupId = String(Math.random() * 10000);
        this.$store.commit("mediasoup/set_mediasoupId", mediasoupId);
        this.$store.commit("mediasoup/onboardingComplete");
        this.$store.commit("mediasoup/set_testViewer");
      }

      if (this.$route.query.proxy) {
        this.$store.commit("mediasoup/set_role", "proxy");
      } else if (this.$route.query.role) {
        this.$store.commit("mediasoup/set_role", this.$route.query.role);
      } else {
        this.$store.commit("mediasoup/set_role", "host");
      }
      // Checking if the user is 'Proxy' and storing it's id in store
      if (this.$route.query.proxy) {
        if (this.$store.getters.getCurrentUser == null) {
          await auth.signInAnonymously();
        }
        let mediasoupId = String(Math.random() * 10000);
        await this.participantsCollection.doc(this.$store.getters.getCurrentUser.uid).set(
          {
            name: this.$route.query.nick,
            lang: this.$route.query.lang.toUpperCase(),
            mediasoupId: mediasoupId,
            lastActive: FieldValue.serverTimestamp(),
            isSupport: Object.keys(this.$route.query).includes("support"),
            reqSwitchToHost: false,
          },
          { merge: true },
        );
        this.$store.commit("mediasoup/set_consumeLang", this.$route.query.lang.toUpperCase());
        this.$store.commit("mediasoup/set_mediasoupId", mediasoupId);
        this.$store.commit("mediasoup/onboardingComplete");
      }
      // checking if the user is 'Hybrid' and storing it's id in vuex store
      if (this.$route.query.role === "hybrid") {
        // await this.setHybridEventType();

        this.$store.commit("mediasoup/set_mediasoupId", "hybridUser");
        this.$store.commit("mediasoup/set_displayName", "hybriduser");
        this.$store.commit("mediasoup/set_consumeLang", "");
        this.$store.commit("mediasoup/set_produce_lang", "");
      }
    } else {
      throw new Error("File: MediasoupEvent.vue, No events found to join!");
    }
  },
  methods: {
    /**
     * Checks if the current Browser is supported
     * @public
     */
    async browserCheck() {
      try {
        let browser = detect();
        this.$store.commit("mediasoup/set_browserName", browser.name);
        if (browser.name == "chrome" && parseFloat(browser.version.split(".")[0]) > 69) {
          console.log("Browser Chrome Okay");
        } else if (browser.name == "firefox" && parseFloat(browser.version.split(".")[0]) > 60) {
          console.log("Browser Firefox Okay");
        } else if (browser.name == "ios" && parseFloat(browser.version.split(".")[0]) >= 11) {
          console.log("Browser Ios Okay");
        } else if (
          browser.name == "safari" &&
          navigator.maxTouchPoints > 2 &&
          parseFloat(browser.version.split(".")[0]) >= 11
        ) {
          console.log("Browser iPadOs Okay");
        } else if (browser.name == "edge-chromium" || browser.name == "Chrome") {
          console.log("Browser Edge on Chromium Okay");
        } else {
          console.log("Browser", browser);
          // window.location.replace(
          //   "https://goqonda.io/unsupported-browser?" +
          //     encodeURIComponent(JSON.stringify({ ...browser }))
          // );
        }
      } catch (err) {
        console.error(err);
      }
    },
    /**
     * sets actual timestamps in firebase for the user
     * @public
     */
    async setActive() {
      if (this.$store.getters.getCurrentUser) {
        if (this.isTranslator) {
          await this.translatorsCollection.doc(this.$store.getters.getCurrentUser.uid).set(
            {
              lastActive: FieldValue.serverTimestamp(),
            },
            { merge: true },
          );
        } else {
          await this.translatorsCollection.doc(this.$store.getters.getCurrentUser.uid).delete();
          await this.participantsCollection.doc(this.$store.getters.getCurrentUser.uid).set(
            {
              lastActive: FieldValue.serverTimestamp(),
            },
            { merge: true },
          );
        }
      }
    },
    async setHybridEventType() {
      db.doc(`organizations/${this.$route.params.organizationId}/events/${this.$route.params.eventId}`).update(
        {
          eventType: "hybrid",
        },
        { merge: true },
      );
    },
  },

  firestore() {
    return {
      event: db.doc(`organizations/${this.$route.params.organizationId}/events/${this.$route.params.eventId}`),
    };
  },
};
</script>
